<template>
  <v-textarea
      v-bind="this.$attrs"
      v-model="localValue"
      @keydown="keydown($event)"
      @click:append="$emit('click:append', $event)">
    <!-- @slot Content of the container -->
    <slot></slot>
  </v-textarea>
</template>

<script>
  /**
   * Passes all attributes to the [v-textare](https://vuetifyjs.com/en/components/textareas) component.
   */
  export default {
    name: 'TextAreaFlyfood',
    props: {
      value: [Number, String],
      alphanumerical: { type: Boolean, default: false }
    },
    computed: {
      localValue: {
        get() {
          return this.value
        },
        set(value) {
          if (this.alphanumerical) {
            value = value.replace(/\W/g, "");
          }
          this.$emit('input', value)
        }
      }
    },
    methods: {
      keydown(e) {
        if (this.alphanumerical) {
          if (/^\W$/.test(e.key)) {
            e.preventDefault();
          }
        }
      },
    }
  }
</script>